import axios from '@/config/backend'

const TOKEN_KEY = 'token_impersonate'
const USER_IMPERSONATED = 'user_impersonated'
const ADMIN_ORIGINAL_USER = 'admin_original_user'
const ADMIN_ORIGINAL_ROLE = 'admin_original_role'
const ADMIN_ORIGINAL_PERMISSIONS = 'admin_original_permissions'

export default class ImpersonateService {
    underImpersonation() {
        return localStorage.getItem(TOKEN_KEY) != null
    }

    userImpersonated() {
        const data = localStorage.getItem(USER_IMPERSONATED)
        return data ? JSON.parse(data) : null
    }

    setToken(data) {
        localStorage.setItem(TOKEN_KEY, data.token)
        localStorage.setItem(USER_IMPERSONATED, JSON.stringify(data.user))
    }

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem(USER_IMPERSONATED)
    }

    saveAdminData() {
        localStorage.setItem(ADMIN_ORIGINAL_USER, localStorage.getItem('user'))
        localStorage.setItem(ADMIN_ORIGINAL_ROLE, localStorage.getItem('role'))
        localStorage.setItem(ADMIN_ORIGINAL_PERMISSIONS, localStorage.getItem('permissions'))
    }

    restoreAdminData() {
        const user = localStorage.getItem(ADMIN_ORIGINAL_USER)
        const role = localStorage.getItem(ADMIN_ORIGINAL_ROLE)
        const permissions = localStorage.getItem(ADMIN_ORIGINAL_PERMISSIONS)

        if (user) localStorage.setItem('user', user)
        if (role) localStorage.setItem('role', role)
        if (permissions) localStorage.setItem('permissions', permissions)

        localStorage.removeItem(ADMIN_ORIGINAL_USER)
        localStorage.removeItem(ADMIN_ORIGINAL_ROLE)
        localStorage.removeItem(ADMIN_ORIGINAL_PERMISSIONS)
    }

    impersonateUser(userId) {
        return axios
            .get(`/api/impersonate-user/${userId}`)
            .then(({ data }) => {
                this.saveAdminData()
                this.setToken(data)
                return data
            })
    }

    leaveImpersonate() {
        this.removeToken()
        this.restoreAdminData()
        return Promise.resolve()
    }
}
